/**
 * A campaign's status as a badge. Campaigns are read only now: the
 * converted welcome reads "Moved to Automations"; one-offs left from before
 * keep their words.
 */
import { Badge } from '@mantine/core';
import { useVocab } from '../../vocab';

const STATUS: Record<string, { label: string; color: string }> = {
  draft: { label: 'Draft', color: 'gray' },
  live: { label: 'Live', color: 'teal' },
  paused: { label: 'Paused', color: 'chartAmber' },
  scheduled: { label: 'Scheduled', color: 'blue' },
  sending: { label: 'Sending', color: 'teal' },
  sent: { label: 'Sent', color: 'gray' },
};

export function StatusBadge({ status }: { status: string }) {
  const v = useVocab();
  const s = status === 'converted'
    ? { label: `Moved to ${v.Many('workflow')}`, color: 'gray' }
    : STATUS[status] ?? { label: status, color: 'gray' };
  return <Badge color={s.color} variant="light" tt="none">{s.label}</Badge>;
}
